import React from "react";

import SearchableOptionsMenu from "@ats/src/components/shared/SearchableOptionsMenu";

interface Props {
  knockoutQuestions: {
    questionIds: number[];
    questionText: string;
  }[];
  filterKeyFor: (knockoutQuestion: { questionIds: number[] }) => string;
  activeFilterKeys: string[];
  disabledFilterKeys: string[];
  onSelect: (filterKey: string) => void;
}

const AddQuestionFilterMenu: React.FunctionComponent<Props> = ({
  knockoutQuestions,
  filterKeyFor,
  activeFilterKeys,
  disabledFilterKeys,
  onSelect,
}) => {
  const options = knockoutQuestions
    .filter((knockoutQuestion) => !activeFilterKeys.includes(filterKeyFor(knockoutQuestion)))
    .map((knockoutQuestion) => ({
      key: filterKeyFor(knockoutQuestion),
      label: knockoutQuestion.questionText,
      isDisabled: disabledFilterKeys.includes(filterKeyFor(knockoutQuestion)),
    }));

  if (options.length === 0) return null;

  return (
    <SearchableOptionsMenu
      text="Add question filter"
      icon="plus"
      searchPlaceholder="Search questions"
      options={options}
      onSelect={onSelect}
      disabledTooltip="No candidates in this hiring stage match this filter."
    />
  );
};

export default AddQuestionFilterMenu;
